import React, { useEffect } from 'react'
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { LoadingSpinner } from '../common'
import { apiScopes } from '../../config/auth'

const RequireAuthentication: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { instance, inProgress } = useMsal()

  useEffect(() => {
    if (inProgress === InteractionStatus.None && instance.getAllAccounts().length === 0) {
      instance.loginRedirect(apiScopes)
    }
  }, [instance, inProgress])

  if (inProgress !== InteractionStatus.None) {
    return <LoadingSpinner fullPage />
  }

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoadingSpinner fullPage />
      </UnauthenticatedTemplate>
    </>
  )
}

export default RequireAuthentication
